import ConditionalWrapper from 'Lib/hoc/ConditionalWrapper';
import PropTypes from 'prop-types';
import { useState } from 'react';

const ShowOnHoverWrapper = ({
  children,
  hoverOverChild,
  alwaysShowCondition,
}) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 2 }}
      onMouseEnter={() => {
        setIsHovering(true);
      }}
      onMouseLeave={() => {
        setIsHovering(false);
      }}>
      <ConditionalWrapper
        condition={!!hoverOverChild}
        wrapper={(children) => [hoverOverChild, children]}>
        <div
          style={{
            opacity: isHovering || alwaysShowCondition ? '1' : '0',
          }}>
          {children}
        </div>
      </ConditionalWrapper>
    </div>
  );
};

ShowOnHoverWrapper.propTypes = {
  children: PropTypes.element,
  hoverOverChild: PropTypes.node,
  alwaysShowCondition: PropTypes.bool,
};
export default ShowOnHoverWrapper;
